// extracted by mini-css-extract-plugin
module.exports = {"hidden":"NavBar_hidden__3FLWt","parent":"NavBar_parent__pN4Ya"};